import { useAtom, useAtomValue } from "jotai";
import { FormEvent } from "react";

import { counterOfferAtom } from "atoms/counterOffer";
import { estimateTotalAtom } from "atoms/estimate";
import { getCurrencyValue } from "utils/stringHelper";

export const useCounterOfferForm = () => {
  const [counterOffer, setCounterOffer] = useAtom(counterOfferAtom);

  const estimateTotal = useAtomValue(estimateTotalAtom);
  const estimateValue = getCurrencyValue(estimateTotal!);
  const isValid = counterOffer !== undefined && counterOffer > estimateValue;

  const handleSubmit = (onSubmit: (counterOffer: number) => void) => (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onSubmit(counterOffer!);
  };

  const onType = (value: number | undefined) => {
    if (value !== undefined) setCounterOffer(value);
  };

  return {
    handleSubmit,
    setCounterOffer,
    counterOffer,
    onType,
    isValid,
  };
};
